import { Link } from "react-router-dom";
import styles from "./Navbar.module.css";
import { about } from "../../data/about";

export default function Navbar() {
  return (
    <header className={styles.navbar}>
      <div className={styles.inner}>
        <Link to="/" className={styles.logo}>
          Yasser Dawa
        </Link>
        <nav className={styles.nav}>
          <a href="/#companies" className={styles.navLink}>
            Companies
          </a>
          <Link to="/eie" className={styles.navLink}>
            EIE
          </Link>
          <Link to="/about" className={styles.navLink}>
            About
          </Link>
          <a href={`mailto:${about.email}`} className={styles.ctaBtn}>
            Get in touch
          </a>
        </nav>
      </div>
    </header>
  );
}
